import { defineComponent as _defineComponent } from 'vue'
import { signInWithRedirect, signOut } from 'firebase/auth'
import { auth } from './firebase'

import { useAuthUserStore, LoginState } from './stores/authUser'
import { googleProvider } from './google-auth'
import { version } from './appConfig'

import NavigationDrawer from './components/NavigationDrawer.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {


const authUserStore = useAuthUserStore()

function login(): void {
  const provider = googleProvider()
  signInWithRedirect(auth, provider)
}

function logout(): void {
  signOut(auth)
}

function isLoggedIn(): boolean {
  return authUserStore.user != null
}

function isLoginStateUnknown(): boolean {
  return authUserStore.loginState == LoginState.Unknown
}


return { __sfc: true,authUserStore, login, logout, isLoggedIn, isLoginStateUnknown, version, NavigationDrawer }
}

})